<template lang="pug">
div
  v-container.mx-0.px-0(fluid, justify-center, align-center)
    v-tabs.mb-2(v-model="activeTab")
      v-tab Página inicial
      v-tab Categorias e Seções
      v-tab Artigos
    faq-inicio(
      v-if="activeTab === 0",
      :categorias="dados.categorias",
      @visualizar="abrirArtigo"
    )
    faq-categorias(
      :ativo="activeTab === 1",
      :dados="dados",
      :pode-editar="podeEditar",
      :recarregar-resumo="recarregarResumo",
      @visualizar="abrirArtigo"
    )
    faq-artigos(
      ref="artigos",
      :recarregar-resumo="recarregarResumo",
      :recarregar-artigos="recarregarArtigos",
      :detalhes-artigos="detalhesArtigos",
      :ativo="activeTab === 2",
      :dados="dados",
      :pode-editar="podeEditar",
      :artigos="listaArtigos"
    )
</template>

<script>
import FaqInicio from "./FaqInicio.vue";
import FaqCategorias from "./FaqCategorias.vue";
import FaqArtigos from "./FaqArtigos.vue";
import normalizarResumoFaq from "@/utils/faqResumo";
import { buscarArtigosFaq, buscarResumoFaq } from "@/api/faq";

export default {
  name: "FaqPage",
  components: { FaqInicio, FaqCategorias, FaqArtigos },
  data: () => ({
    activeTab: 0,
    requisicaoResumo: 0,
    requisicaoArtigos: 0,
    detalhesArtigos: [],
    dados: { categorias: [] }
  }),
  computed: {
    podeEditar() {
      const roles = this.$store.state.auth.user?.roles || [];
      return roles.some(role => Number(role.projectid) === 315 && Number(role.id) === 10);
    },
    listaArtigos() {
      const artigos = new Map();
      this.dados.categorias.forEach(categoria => {
        categoria.secoes.forEach(secao => {
          secao.artigos.forEach(artigo => {
            if (!artigos.has(artigo.id)) {
              artigos.set(artigo.id, {
                id: artigo.id,
                status: artigo.status,
                permissao: artigo.permissao,
                autor: artigo.autor,
                editors: artigo.editors,
                alteradopor: artigo.alteradopor,
                titulo: artigo.titulo,
                atualizadoem: artigo.atualizadoem,
                categorias: [],
                categoriaIds: [],
                secoes: [],
                secaoIds: [],
                categoria: "",
                secaoTitulo: "",
                secao,
                artigo
              });
            }
            const item = artigos.get(artigo.id);
            if (!item.categorias.includes(categoria.titulo)) {
              item.categorias.push(categoria.titulo);
            }
            if (!item.categoriaIds.includes(categoria.id)) {
              item.categoriaIds.push(categoria.id);
            }
            if (!item.secoes.includes(secao.titulo)) {
              item.secoes.push(secao.titulo);
            }
            if (!item.secaoIds.includes(secao.id)) {
              item.secaoIds.push(secao.id);
            }
          });
        });
      });
      return Array.from(artigos.values()).map(artigo => ({
        ...artigo,
        categoria: artigo.categorias.join(", "),
        secaoTitulo: artigo.secoes.join(", ")
      }));
    }
  },
  methods: {
    async recarregarArtigos() {
      const requisicao = ++this.requisicaoArtigos;
      const artigos = await buscarArtigosFaq();
      if (!Array.isArray(artigos)) throw new Error("Formato inválido na lista de artigos");
      if (!this._isDestroyed && !this._isBeingDestroyed && requisicao === this.requisicaoArtigos) this.detalhesArtigos = artigos;
      return artigos;
    },
    async recarregarResumo(exibirLoader = true) {
      const requisicao = ++this.requisicaoResumo;
      const categorias = normalizarResumoFaq(await buscarResumoFaq(exibirLoader));
      if (!this._isDestroyed && !this._isBeingDestroyed && requisicao === this.requisicaoResumo) this.dados.categorias = categorias;
      return categorias;
    },
    abrirArtigo(artigo) {
      this.$refs.artigos.abrirArtigo(artigo);
    }
  }
};
</script>

<style src="./faq.css"></style>
